/**
 * QuickActions — Action buttons grid: New Agent, Connect Channel, View Inbox, Usage Report.
 */
import { useNavigate } from "react-router-dom";
import { Bot, Radio, Inbox, BarChart3 } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/Card";

interface QuickAction {
  icon: typeof Bot;
  label: string;
  description: string;
  path: string;
}

const actions: QuickAction[] = [
  {
    icon: Bot,
    label: "New Agent",
    description: "Create an agent template",
    path: "/dashboard/sessions",
  },
  {
    icon: Radio,
    label: "Connect Channel",
    description: "Add Slack, Email, or SMS",
    path: "/dashboard/channels",
  },
  {
    icon: Inbox,
    label: "View Inbox",
    description: "See pending messages",
    path: "/dashboard/notifications",
  },
  {
    icon: BarChart3,
    label: "Usage Report",
    description: "View tokens & costs",
    path: "/dashboard/billing",
  },
];

export function QuickActions() {
  const navigate = useNavigate();

  return (
    <Card data-testid="quick-actions">
      <CardHeader>
        <CardTitle>Quick Actions</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-3">
          {actions.map((action) => (
            <button
              key={action.label}
              onClick={() => navigate(action.path)}
              className="flex flex-col items-center gap-2 rounded-lg border border-white/10 bg-surface p-4 text-center transition-colors hover:border-primary/30 hover:bg-primary/5"
            >
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10 text-primary">
                <action.icon className="h-5 w-5" />
              </div>
              <span className="text-sm font-medium text-foreground">
                {action.label}
              </span>
              <span className="text-xs text-muted-foreground">
                {action.description}
              </span>
            </button>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
